import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import authSlice from "./Auth/authStore";
import logger from "redux-logger";
import bonusSlice from "./Bonus/bonusStore";
import triggerSlice from "./Trigger/triggerStore";
import gamesSlice from "./Games/gamesStore";
import jackpotsSlice from "./JackpotGame/jackpotStore";
import jackpotSlice from "./JackpotGame/Jackpot/jackpotStore";
import jackpotProfileSlice from "./JackpotGame/Jackpot/profileStore";
import caseSlice from "./CaseGame/caseStore";
import notificationSlice from "./Notification/notificateStore";
import webhookSlice from "./Webhook/webhookStore";
import eventSlice from './Event/eventStore'
import cohortSlice from './Cohortes/cohortesStore'
import { piggyBankReducer } from "./PiggyBankGame/piggyBankReducer";
import { wheelReducer } from "./WheelGame/wheelReducer";
import { coinFlipReducer } from "./CoinFlipGame/coinFlipReducer";
import { fortuneWheelReducer } from "./WheelGame_v2/fortuneWheelReducer";
import { v3GamesReducer } from "./CustomeGame/v3GameReducers";
import { casesReducer } from "./Cases_v2/casesReducer";
import analyticsSlice from './Analytics/analyticsStore'
import ruleSlice from './Rules/rulesStore'
import currencySlice from './Currency/currencyStore'
import usersSlice from './Users/usersStore'

const jackpotReducer = combineReducers({
  tables: jackpotsSlice,
  jackpot: jackpotSlice,
  profile: jackpotProfileSlice,
});

const rootReducer = combineReducers({
  auth: authSlice,
  bonus: bonusSlice,
  trigger: triggerSlice,
  games: gamesSlice,
  wheel: wheelReducer,
  jackpot: jackpotReducer,
  cases: casesReducer,
  case: caseSlice,
  notification: notificationSlice,
  webhook: webhookSlice,
  event: eventSlice,
  piggyBank: piggyBankReducer,
  coinFlip: coinFlipReducer,
  cohort: cohortSlice,
  fortuneWheel: fortuneWheelReducer,
  v3Games: v3GamesReducer,
  analytics: analyticsSlice,
  rule: ruleSlice,
  currency: currencySlice,
  users: usersSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    process.env.NODE_ENV === "development"
      ? getDefaultMiddleware().concat(logger)
      : getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
